<div
  class="initials-badge"
  [ngStyle]="{
    width: size + 'px',
    height: size + 'px',
    'font-size': fontSize,
    'background-color': background,
  }"
>
  {{ initials }}
</div>
